export default __webpack_public_path__ + "static/media/blue-loader.581b152f.svg";